<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <RedirectBack></RedirectBack>
        <span>Enviar publipost</span>
      </h1>
      <div class="d-flex">
        <PrimaryButton v-if="!loading && !notifications.messages" class="px-5" @click="submit()" icon="fa-solid fa-paper-plane">
          Enviar
        </PrimaryButton>
      </div>
    </div>
  </div>

  <div v-if="!loading" class="align p-4 space_title">

    <AlertMessages/>

    <div v-if="publipostCheck.length">
      <div class="card p-4 mb-4" id="publipost_check">
        <h6 class="mb-3">
          <i class="fa-regular fa-circle-exclamation me-1"></i>
          Revise os trechos
          abaixo e envie novamente
        </h6>
        <ul>
          <li v-for="(item, key) in publipostCheck" :key="key" class="mt-2">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>

    <div class="col-12 mb-3" v-if="publipost.id">
      <span class="badge mb-1 me-2" :style="'background-color: ' + publipost.status_color">{{ publipost.status_name }}</span>
    </div>

    <div class="row">

      <div class="col-12 col-lg-8 mb-4">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <div class="col-12 mb-3">
                <InputText label="Título" v-model="publipost.title" :error="formErrors.title"/>
              </div>

              <div class="col-12 mb-3">
                <InputText label="Subtitulo" v-model="publipost.subtitle" :error="formErrors.subtitle"/>
              </div>

              <div class="col-12 mb-3">
                <TextArea label="Observações" v-model="publipost.observations" :error="formErrors.observations"
                          style="height: 90px"/>
              </div>

              <div class="col-12 mb-3">
                <ArticleEditor v-model="publipost.content" :idSite="publipost.id_site" :error="formErrors.content"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-4">
        <div class="card">
          <div class="p-4">
            <div class="row">
              <ImageUpload v-model="publipost.cover_image" :preview="publipost.cover_image_file_url"
                           :error="formErrors.cover_image"/>

              <div class="col-12 mb-4">
                <PrimaryButton class="w-100 mt-3" @click="showSearchImageModal = true">Buscar imagem</PrimaryButton>
              </div>

              <div class="col-12 mb-3">
                <InputText label="Créditos da imagem" v-model="publipost.cover_image_credits"
                           :error="formErrors.cover_image_credits"/>
              </div>

              <div class="col-12 mb-2 references_multiple">
                <label>Links de fontes da imagem</label>

                <div class="mb-2 reference_item"
                     v-for="(reference, index) in publipost.references.filter(ref => ref.type === 'image')"
                     :key="index">
                  <div class="d-flex"
                       v-if="(index + 1) === publipost.references.filter(ref => ref.type === 'image').length">
                    <InputText class="w-100" v-model="reference.url"
                               :error="index === 0 ? formErrors.references_image : null"/>
                    <PrimaryButton id="add_reference" @click="addReference('image')">+</PrimaryButton>
                  </div>

                  <div v-else>
                    <InputText class="w-100" v-model="reference.url"
                               :error="index === 0 ? formErrors.references_image : null"/>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <InputTag label="Tags" v-model="publipost.tags" :error="formErrors.tags"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ModalDialog width="700px" title="Buscar imagem" v-model="showSearchImageModal">
    <InputText placeholder="Buscar..." v-model="searchImage" @keyup="debouncedSearchImages"/>
    <div id="search_images" class="mt-3">
      <div class="row">
        <div class="image col-6 mb-3" v-for="(image, key) in images" :key="key">
          <img :src="image.cover_image"
               @click="selectImage(image.id, image.cover_image, image.cover_image_credits, image.cover_image_references)"/>
          <small class="text-center d-block mt-2">{{ image.cover_image_credits }}</small>
        </div>
      </div>
    </div>
  </ModalDialog>
</template>

<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import InputTag from '@/components/InputTag.vue'
import RedirectBack from '@/components/RedirectBack.vue'
import AlertMessages from '@/components/AlertMessages.vue'

import {inject, onBeforeMount, onMounted, ref} from 'vue'
import ImageUpload from '@/components/ImageUpload.vue'
import {usePublipostStore} from '@/stores/PublipostStore'
import {useSiteStore} from '@/stores/SiteStore'

import {storeToRefs} from 'pinia'
import {useToast, TYPE} from "vue-toastification"
import {useRoute, useRouter} from 'vue-router'
import ModalDialog from '@/components/ModalDialog.vue'
import axios from 'axios'
import {useAuthStore} from '@/stores/AuthStore'
import TextArea from '@/components/TextArea.vue'
import {errorFormat} from "@/utils/errorFormat";
import ArticleEditor from "@/components/ArticleEditor.vue";

const toast = useToast();
const loader = inject('$loader');
const loading = ref(false);
const processing = ref(false);

const router = useRouter();
const route = useRoute();

const publipostStore = usePublipostStore();
const {publipost, images} = storeToRefs(publipostStore);

const siteStore = useSiteStore();

const authStore = useAuthStore();
const {notifications} = storeToRefs(authStore);

const publipostCheck = ref({});
const showSiteModal = ref(false);

onBeforeMount(async () => {
  publipost.value = {};
  publipost.value.references = [];
  images.value = {};
  loader.show();
  await siteStore.getSitesList();
  loader.hide();
});

onMounted(async () => {
  const id = route.params.id;
  if (route.name == 'publipostEdit') {
    loader.show();
    loading.value = true;

    await publipostStore.getPublipost(id);

    loader.hide();
    loading.value = false;
  } else {
    showSiteModal.value = true;
  }

  if (!publipost.value.references.some(ref => ref.type === 'publipost')) {
    publipost.value.references.push({type: 'publipost', url: null});
  }

  if (!publipost.value.references.some(ref => ref.type === 'image')) {
    publipost.value.references.push({type: 'image', url: null});
  }

});

const formErrors = ref({});

const submit = async (type = null) => {
  if (processing.value == true) {
    return;
  }

  let params = {
    title: publipost.value.title,
    subtitle: publipost.value.subtitle,
    references_image: publipost.value.references.filter(item => item.type === 'image').map(item => item.url),
    references_publipost: publipost.value.references.filter(item => item.type === 'publipost').map(item => item.url),
    content: publipost.value.content,
    id_site: publipost.value.id_site,
    category: publipost.value.category,
    tags: publipost.value.tags,
    cover_image: publipost.value.cover_image,
    cover_image_credits: publipost.value.cover_image_credits,
    cover_image_url: publipost.value.cover_image_url,
    id_selected_cover_image: publipost.value.id_selected_cover_image,
    observations: publipost.value.observations,
  };

  loader.show();
  formErrors.value = {};
  processing.value = true;

  const formResult = await publipostStore.updatePublipost(route.params.id, params);

  if (formResult.success) {

    if (type !== 'draft') {
      toast('Notícia enviada', {type: TYPE.SUCCESS, timeout: 6000});
      router.push({name: 'publiposts'});
    } else {
      toast('Notícia atualizada', {type: TYPE.SUCCESS, timeout: 6000});
      router.push({name: 'publiposts'});
    }
  } else {
    formErrors.value = errorFormat(formResult.errors)

    if (formResult.message) {
      toast(formResult.message, {type: TYPE.ERROR, timeout: 6000});
    }
  }

  processing.value = false;
  loader.hide();
};

const addReference = (type) => {
  if (publipost.value.references.length == 20) {
    return;
  }
  publipost.value.references.push({type: type, url: ''});
};

const showSearchImageModal = ref(false);
let cancelTokenSource = null;
let searchImage = ref(null);

async function searchImages(event) {

  loader.show();
  publipostStore.filter.page = parseInt(route.query.page);
  window.scrollTo(0, 0);

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Cancelado devido a nova busca');
  }

  const source = axios.CancelToken.source();
  cancelTokenSource = source;

  let params = {
    search: event.target.value,
  }

  try {
    const result = await publipostStore.searchImages(params, source);

    if (!result.success && result.message) {
      toast(result.message, {type: TYPE.ERROR, timeout: 6000});
    }
  } finally {
    // Só a busca mais recente controla o loader; as canceladas não o desligam.
    if (cancelTokenSource === source) {
      loader.hide();
    }
  }
}

const debouncedSearchImages = debounce(searchImages, 300);

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

const selectImage = (id, coverImage, coverImageCredits, coverImageReferences) => {
  publipost.value.id_selected_cover_image = id;
  publipost.value.cover_image = null;
  publipost.value.cover_image_file_url = coverImage;
  publipost.value.cover_image_credits = coverImageCredits;
  publipost.value.cover_image_url = null;

  publipost.value.references = publipost.value.references.filter(reference => reference.type !== 'image');

  let netCoverImageReference = coverImageReferences.map(url => ({
    type: 'image',
    url: url
  }));

  publipost.value.references = [...publipost.value.references, ...netCoverImageReference];

  showSearchImageModal.value = false;
};
</script>

<style scoped>
#add_reference {
  height: 43px;
  margin-left: 10px;
}

.counter {
  display: inline-block;
  background-color: #583a8e;
  padding: 2px 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  color: #fff;
}

#search_images .image img {
  width: 100%;
  cursor: pointer;
}

#search_images .image:hover {
  opacity: 0.5;
}

#search_images {
  max-height: 510px;
  overflow-y: auto;
  overflow-x: hidden;
}

#add_reference {
  margin-top: 4px;
}

.reference_item:first-child #add_reference {
  margin-top: 25px;
}

.alert {
  background-color: #f6aa10;
}

#publipost_check {
  border: 2px #dda40e solid;
}

#publipost_check ul {
  padding: 0;
  margin-bottom: 0;
}

#publipost_check ul li {
  background-color: #ececec;
  padding: 15px;
  border-radius: 6px;
  list-style: none;
  border: 0;
  font-weight: 500;
}

.dark #publipost_check ul li {
  background-color: #1b2127;
}

.dropdown_button::after {
  display: none;
}
</style>